/* eslint-disable max-lines */
const buildSortMenu = (field) => ({
  type: 'sort',
  field,
  showSortButtonInHeader: false,
  options: [
    { label: 'Sort Ascending', icon: 'pi pi-arrow-up', order: 1 },
    { label: 'Sort Descending', icon: 'pi pi-arrow-down', order: -1 },
  ],
});

const toFilterOption = (value) => {
  if (value && typeof value === 'object') {
    const val = String(value.value ?? value.id ?? value.name ?? value.label ?? '').trim();
    const label = String(value.label ?? value.name ?? value.value ?? '').trim();
    return {
      id: val || '[object Object]',
      name: label || '[object Object]',
      label: label || '[object Object]',
      value: val || '[object Object]',
    };
  }
  const normalizedValue = String(value ?? '').trim();
  return {
    id: normalizedValue,
    name: normalizedValue,
    label: normalizedValue,
    value: normalizedValue,
  };
};

const buildGlobalFilterMenuItems = (field, header, values = [], sortField) => [
  {
    label: header,
    items: [
      buildSortMenu(sortField || field),
      { separator: true },
      {
        type: 'filter',
        field,
        label: header,
        template: 'multiSelect',
        selectedValues: [],
        value: [],
        options: values.map(toFilterOption),
        values: values.map(toFilterOption),
      },
    ],
  },
];

const buildColumn = ({
  field,
  header,
  width,
  order,
  sortable = true,
  filter = false,
  isGlobalFilter = false,
  visible = true,
  align,
  className = '',
  headerClassName = '',
  sortField,
  filterField,
  menuItems = [],
  showFilterButtonInHeader = false,
  filterVisible = true,
  ellipsis = false,
}) => ({
  field,
  header,
  width,
  minWidth: width,
  order,
  filter,
  isGlobalFilter,
  visible,
  sortable,
  pinnable: false,
  defaultPinned: false,
  showFilterButtonInHeader,
  filterVisible,
  showPinButtonInHeader: false,
  menuItems,
  ellipsis,
  sortField: sortField || field,
  filterField: filterField || field,
  ...(align ? { align, headerAlign: align } : {}),
  ...(className ? { className, bodyClassName: className } : {}),
  ...(headerClassName ? { headerClassName } : {}),
});

export const buildCsatCustomerDetailsTableConfig = (filterOptions = {}) => [
  buildColumn({
    field: 'projectId',
    header: 'Project ID',
    width: 224.4,
    sortable: true,
    filter: true,
    isGlobalFilter: true,
    menuItems: buildGlobalFilterMenuItems(
      'projectId',
      'Project ID',
      filterOptions.projectId || [],
      'projectId',
    ),
    className: 'col-project-id',
    headerClassName: 'col-project-id',
  }),
  buildColumn({
    field: 'projectName',
    header: 'Project Name',
    width: 224.4,
    sortable: true,
    filter: true,
    isGlobalFilter: true,
    menuItems: buildGlobalFilterMenuItems(
      'projectName',
      'Project Name',
      filterOptions.projectName || [],
      'projectName',
    ),
    className: 'col-project-name',
    headerClassName: 'col-project-name',
    ellipsis: true,
  }),
  buildColumn({
    field: 'customerName',
    header: 'Customer Name',
    width: 224.4,
    sortable: true,
    filter: true,
    isGlobalFilter: true,
    menuItems: buildGlobalFilterMenuItems(
      'customerName',
      'Customer Name',
      filterOptions.customerName || [],
      'customerName',
    ),
    className: 'col-customer-name',
    headerClassName: 'col-customer-name',
    ellipsis: true,
  }),
  buildColumn({
    field: 'customerEmail',
    header: 'Customer Email',
    width: 224.4,
    sortable: true,
    filter: true,
    isGlobalFilter: true,
    menuItems: buildGlobalFilterMenuItems(
      'customerEmail',
      'Customer Email',
      filterOptions.customerEmail || [],
      'customerEmail',
    ),
    className: 'col-customer-email',
    headerClassName: 'col-customer-email',
    ellipsis: true,
  }),
  buildColumn({
    field: 'comments',
    header: 'Comments',
    width: 224.4,
    sortable: true,
    filter: false,
    className: 'col-comments',
    headerClassName: 'col-comments',
    ellipsis: true,
  }),
  buildColumn({
    field: 'action',
    header: 'Action',
    width: 93,
    align: 'center',
    sortable: false,
    menuItems: [],
    visible: true,
    className: 'col-action',
    headerClassName: 'col-action',
  }),
];
